import React from 'react';

import ConfigTablePage from '../../../components/ConfigTablePage';
import BadgeForm from '../../../components/BadgeForm';
import LineItem from '../../../components/LineItem';
import { listBadges, deleteBadge } from '../../../api';

const holder = (b) => {
  const s = b.getBelongsTo();
  return s ? [s.firstName, s.lastName].filter(Boolean).join(' ') : null;
};
const seen = (b) => b.getLastSeenTimestamp()?.toLocaleString({ month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });

const COLUMNS = [
  { label: 'Serial number', width: '140px', minWidth: 140, render: (b) => String(b.getSerialNumber()) },
  { label: 'Badge type', width: '120px', minWidth: 120, render: (b) => b.getBadgeType()?.getName() },
  { label: 'Assigned to', width: 'minmax(170px, 1fr)', minWidth: 170, render: holder },
  { label: 'Last seen', width: '140px', minWidth: 140, render: seen },
  { label: 'Firmware', width: '100px', minWidth: 100, render: (b) => b.getFirmwareVersion() }
];

export default function Badges() {
  return (
    <ConfigTablePage
      title='Badges'
      singular='badge'
      columns={COLUMNS}
      load={listBadges}
      idOf={(b) => b.getSerialNumber()}
      searchText={(b) => [b.getSerialNumber(), holder(b)].filter(Boolean).join(' ')}
      searchPlaceholder='Search serial or name'
      addLabel='Assign badge'
      renderForm={(row, onSaved) => <BadgeForm onSuccess={onSaved} />}
      renderView={(row) => (
        <div style={{ paddingTop: 8 }}>
          <LineItem description='Serial number' value={String(row.getSerialNumber())} mono />
          <LineItem description='Assigned to' value={holder(row) ?? 'Unassigned'} />
          <LineItem description='Badge type' value={row.getBadgeType()?.getName() ?? 'Unknown'} />
          <LineItem description='Last seen' value={seen(row)} />
          <LineItem description='Firmware' value={row.getFirmwareVersion()} mono last />
        </div>
      )}
      viewTitle={(row) => 'Badge ' + row.getSerialNumber()}
      remove={(row) => deleteBadge(row.getSerialNumber())}
      deleteTitle={(row) => 'Delete badge ' + row.getSerialNumber() + '?'}
      deleteBody='The badge will no longer be able to receive or send alerts.'
      deleted={(row) => 'Badge ' + row.getSerialNumber() + ' deleted.'}
    />
  );
}
